import { useState } from "react";

// styles
import './quick-view.styles.scss';

// components
import { Button } from 'shared/components/bulma/button';

const DefaultQuickViewButton = ({ onClick }) => {

    const handleClick = (event) => {
        onClick && onClick(event);
    }

    return (
        <Button className="is-light" onClick={handleClick}>
            <span className="fa fa-bars is-size-4"></span>
        </Button>
    );
}

const QuickView = ({ title, QuickViewButton = DefaultQuickViewButton, children }) => {

    const [isActive, setActive] = useState(false);

    const handleClick = () => {
        setActive(!isActive);
    }

    if (!isActive) {
        return (
            <QuickViewButton onClick={handleClick} />
        );
    }

    return (
        <div className="quickview quick-view-index is-active">
            <header className="quickview-header has-background-light">
                {title}
                <span className="delete" data-dismiss="quickview" onClick={handleClick} />
            </header>

            <div className="quickview-body">
                <div className="quickview-block">
                    {children}
                </div>
            </div>
        </div>
    );
};

export { QuickView };
